import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
   // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[matDatepicker]'
})
export class FilterCharsDirective {

  isDatepicker = false;
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInput(evt: any) {
    
    const inputIndex = this.el.nativeElement.className.indexOf('mat-datepicker-input');
    this.isDatepicker = inputIndex !== -1 ? true : false;
    
    if(this.isDatepicker) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.target.value = this.removeChars(evt.target.value);
    }
  }

  private removeChars(input: string) {
    const pattern = /^[0-9/]*$/;
    let value = input;

    if (!pattern.test(value)) {
      return value = value.replace(/[^0-9/]/g, "");
    }
    return value;
  }

}